module.exports = __webpack_public_path__ + "img/Warlock-human-f-70.ff8301ab.gif";